import styled from 'styled-components';

export const Loading = styled.div`
    position: fixed;
    bottom: 0;
    left: 30px;
    height: 40px;
    padding: 10px 10px 10px 40px;
    box-sizing: border-box;
    z-index: 1000;
    opacity: 0;
    color: #fff;
    transform: translate3d(0, 100%, 0);
    transition: all .3s ease 0s;
    border: 1px solid #fff;
    background-color: #111;

    &:before {
        content: '';
        position: absolute;
        top: 9px;
        left: 10px;
        border: 3px solid transparent;
        border-left: 3px solid #fff;
        border-top: 3px solid #fff;
        border-radius: 15px;
        box-sizing: border-box;
        width: 20px;
        height: 20px;
        animation: loading forwards infinite 1s linear;
    }

    &.active {
        opacity: 1;
        transform: translate3d(0, -30px, 0);
    }
`;
